import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ElementsState } from '../reducers/elements.reducer';
import { ELEMENTS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<ElementsState>(ELEMENTS_FEATURE_KEY);

export const selectElements = createSelector(selectState, (state: ElementsState) => state.elements);
export const selectLoaded = createSelector(selectState, (state: ElementsState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: ElementsState) => state.loading);
export const selectValue = createSelector(selectState, (state: ElementsState) => state.value);
export const selectTotal = createSelector(selectState, (state: ElementsState) => state.total);
export const selectLookupLoaded = createSelector(selectState, (state: ElementsState) => state.lookupLoaded);
export const selectLookup = createSelector(selectState, (state: ElementsState) => state.lookup);
